import React from "react";
import { List, Avatar, Button } from "antd";
import { useAuth } from "../../hooks/AuthContext";
import { useNavigate } from "react-router-dom";
import { MdPerson } from "react-icons/md";
import Status from "../status";
import { format } from "date-fns";

const ChatList = ({ chats, onSelectChat }) => {
  const { user } = useAuth();
  const navigate = useNavigate();
  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
      <div className="chat-header">{"Chamados em aberto"}</div>
      <div
        className="chat-list-body"
        style={
          chats.lenght == 0
            ? {
                justifyContent: "flex-end",
              }
            : {
                flexDirection: "column",
              }
        }
      >
        <List
          itemLayout="horizontal"
          dataSource={chats}
          renderItem={(item) => {
            const messagesNotView = item.messages.filter((item) => {
              return item.send_id != user.id && !item.is_viewed;
            }).length;

            return (
              <div
                style={{
                  cursor: "pointer",
                  padding: "16px",
                  borderBottom: "1px solid #f0f2f5",
                }}
              >
                <div
                  style={{
                    width: "100%",
                    justifyContent: "space-between",
                    display: "flex",
                  }}
                >
                  <p
                    style={{
                      flex: 1,
                    }}
                  >
                    {item.protocol_id}
                  </p>
                  <div
                    style={{
                      display: "flex",
                    }}
                  >
                    {!!item.order_id && (
                      <Button
                        type="primary"
                        style={{
                          borderRadius: 50,
                          height: 20,
                        }}
                        onClick={() => {
                          navigate(`/${user.type}/os/${item.order_id}`);
                        }}
                      >
                        {item.order_id}
                      </Button>
                    )}
                    <Status
                      style={{ marginBottom: 0, marginLeft: 16 }}
                      isAttendant={true}
                      isMini={true}
                      status={item.status}
                    />
                  </div>
                </div>
                <List.Item
                  onClick={() => onSelectChat(item, messagesNotView)}
                  style={{
                    border: "none",
                    padding: "8px 0",
                  }}
                >
                  <List.Item.Meta
                    avatar={
                      <Avatar
                        src={item.attendant?.photo_url || null}
                        icon={<MdPerson />}
                      />
                    }
                    title={item.attendant?.name || "Aguardando atendente"}
                    description={item.messages[0]?.content}
                  />
                  {!!messagesNotView && (
                    <div
                      style={{
                        borderRadius: 50,
                        width: 26,
                        height: 26,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        background: "#FF5D5D",
                        color: "#FFF",
                        fontSize: 12,
                      }}
                    >
                      {messagesNotView}
                    </div>
                  )}
                </List.Item>
                <div
                  style={{
                    width: "100%",
                    textAlign: "end",
                  }}
                >
                  <p>
                    {format(
                      new Date(item.messages[0]?.created_at),
                      "dd/MM/yyyy HH:mm"
                    )}
                  </p>
                </div>
              </div>
            );
          }}
        />
      </div>
      <div className="chat-list-footer">
        <Button
          type="primary"
          onClick={() => {
            navigate(`/${user.type}/chamados`);
          }}
        >
          {"Chamados finalizados "}
        </Button>
      </div>
    </div>
  );
};

export default ChatList;
